import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";

// components
import Header from "./components/Header";
import Footer from "./components/Footer";
import Loader from "./components/Loader";
import Player from "./components/Player";

// pages
const Home = React.lazy(() => import("./pages/Home/Home"));
const Courses = React.lazy(() => import("./pages/Courses/Courses"));
// web design
const HTML = React.lazy(() => import("./pages/Courses/WebDesign/HTML"));
const CSS = React.lazy(() => import("./pages/Courses/WebDesign/CSS"));
const Bootstrap4 = React.lazy(() =>
  import("./pages/Courses/WebDesign/Bootstrap4")
);
const Bootstrap5 = React.lazy(() =>
  import("./pages/Courses/WebDesign/Bootstrap5")
);
const SCSS = React.lazy(() => import("./pages/Courses/WebDesign/SCSS"));
const TailwindCSS = React.lazy(() =>
  import("./pages/Courses/WebDesign/TailwindCSS")
);
// MERN Stack
const NodeJS = React.lazy(() => import("./pages/Courses/MERN/NodeJS"));
const ExpressJS = React.lazy(() => import("./pages/Courses/MERN/ExpressJS"));
const MongoDB = React.lazy(() => import("./pages/Courses/MERN/MongoDB"));
const ReactJS = React.lazy(() => import("./pages/Courses/MERN/ReactJS"));
const Redux = React.lazy(() => import("./pages/Courses/MERN/Redux"));
const ReactTypescript = React.lazy(() => import("./pages/Courses/MERN/ReactTypescript"));
// Programming
const Programming = React.lazy(() => import("./pages/Programming/Programming"));
const C = React.lazy(() => import("./pages/Programming/C"));
const CPP = React.lazy(() => import("./pages/Programming/CPP"));
const Java = React.lazy(() => import("./pages/Programming/Java"));
const Python = React.lazy(() => import("./pages/Programming/Python"));
const Golang = React.lazy(() => import("./pages/Programming/Golang"));
const JavaScript = React.lazy(() => import("./pages/Programming/JS"));
const TypeScript = React.lazy(() => import("./pages/Programming/TS"));
// Computer Science
const CSE = React.lazy(() => import("./pages/CSE/CSE"));
const DiscreteMathematics = React.lazy(() =>
  import("./pages/CSE/DiscreteMathematics")
);
const ArtificialIntelligence = React.lazy(() =>
  import("./pages/CSE/ArtificialIntelligence")
);
const CompilerDesign = React.lazy(() => import("./pages/CSE/CompilerDesign"));
const Networking = React.lazy(() => import("./pages/CSE/Networking"));
const NumericalMethods = React.lazy(() =>
  import("./pages/CSE/NumericalMethods")
);
const OperatingSystem = React.lazy(() => import("./pages/CSE/OperatingSystem"));
const TheoryOfComputation = React.lazy(() =>
  import("./pages/CSE/TheoryOfComputation")
);
// Android
const Android = React.lazy(() => import("./pages/Android/Android"));
const AJava = React.lazy(() => import("./pages/Android/Java"));
const AStudio = React.lazy(() => import("./pages/Android/AndroidStudio"));
const AFirebase = React.lazy(() => import("./pages/Android/AndroidFirebase"));
const ASQLite = React.lazy(() => import("./pages/Android/AndroidSQLite"));

// Others
const Others = React.lazy(() => import("./pages/Others/Others"));
const Github = React.lazy(() => import("./pages/Others/Github"));
const JSON = React.lazy(() => import("./pages/Others/JSON"));
const RestAPI = React.lazy(() => import("./pages/Others/RestAPI"));
const Ejs = React.lazy(() => import("./pages/Others/Ejs"));
const Terminal = React.lazy(() => import("./pages/Others/Terminal"));

// HSC ICT
const HSC = React.lazy(() => import("./pages/HSC/HSC"));
const Chapter3 = React.lazy(() => import("./pages/HSC/NumberSystem"));
const Chapter4 = React.lazy(() => import("./pages/HSC/WebDesign"));
const Chapter5 = React.lazy(() => import("./pages/HSC/CProgramming"));
const Chapter6 = React.lazy(() => import("./pages/HSC/Database"));

// Basic Computer
const BasicComputer = React.lazy(() =>
  import("./pages/Basic-Computer/BasicComputer")
);
const MSWord = React.lazy(() => import("./pages/Basic-Computer/MSWord"));
const MSExcel = React.lazy(() => import("./pages/Basic-Computer/MSExcel"));
const MSPowerpoint = React.lazy(() =>
  import("./pages/Basic-Computer/MSPowerpoint")
);

const Contact = React.lazy(() => import("./pages/Contact/Contact"));
const Admin = React.lazy(() => import("./components/Admin"));
const FourOFour = React.lazy(() => import("./components/FourOFour"));

function App() {
  return (
    <BrowserRouter>
      <Header />
      <ScrollToTop
        smooth={true}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "dodgerblue",
          left: "3%",
          bottom: "3%",
        }}
      />
      <Routes>
        <Route
          path="/anisul-islam/watch/:id"
          element={
            <React.Suspense fallback={<Loader />}>
              <Player />
            </React.Suspense>
          }
        />
        <Route
          path="/"
          element={
            <React.Suspense fallback={<Loader />}>
              <Home />
            </React.Suspense>
          }
        />
        <Route
          path="/courses"
          element={
            <React.Suspense fallback={<Loader />}>
              <Courses />
            </React.Suspense>
          }
        />
        {/* Web Design */}
        <Route
          path="/courses/web-design/html"
          element={
            <React.Suspense fallback={<Loader />}>
              <HTML />
            </React.Suspense>
          }
        />
        <Route
          path="/courses/web-design/css"
          element={
            <React.Suspense fallback={<Loader />}>
              <CSS />
            </React.Suspense>
          }
        />
        <Route
          path="/courses/web-design/bootstrap4"
          element={
            <React.Suspense fallback={<Loader />}>
              <Bootstrap4 />
            </React.Suspense>
          }
        />
        <Route
          path="/courses/web-design/bootstrap5"
          element={
            <React.Suspense fallback={<Loader />}>
              <Bootstrap5 />
            </React.Suspense>
          }
        />
        <Route
          path="/courses/web-design/scss"
          element={
            <React.Suspense fallback={<Loader />}>
              <SCSS />
            </React.Suspense>
          }
        />
        <Route
          path="/courses/web-design/tailwindcss"
          element={
            <React.Suspense fallback={<Loader />}>
              <TailwindCSS />
            </React.Suspense>
          }
        />
        {/* MERN Stack */}
        <Route
          path="/courses/mern-stack/nodejs"
          element={
            <React.Suspense fallback={<Loader />}>
              <NodeJS />
            </React.Suspense>
          }
        />
        <Route
          path="/courses/mern-stack/expressjs"
          element={
            <React.Suspense fallback={<Loader />}>
              <ExpressJS />
            </React.Suspense>
          }
        />
        <Route
          path="/courses/mern-stack/mongodb"
          element={
            <React.Suspense fallback={<Loader />}>
              <MongoDB />
            </React.Suspense>
          }
        />
        <Route
          path="/courses/mern-stack/reactjs"
          element={
            <React.Suspense fallback={<Loader />}>
              <ReactJS />
            </React.Suspense>
          }
        />
        <Route
          path="/courses/mern-stack/redux"
          element={
            <React.Suspense fallback={<Loader />}>
              <Redux />
            </React.Suspense>
          }
        />
        <Route
          path="/courses/mern-stack/reactTypescript"
          element={
            <React.Suspense fallback={<Loader />}>
              <ReactTypescript />
            </React.Suspense>
          }
        />
        {/* Programming */}
        <Route
          path="/programming"
          element={
            <React.Suspense fallback={<Loader />}>
              <Programming />
            </React.Suspense>
          }
        />
        <Route
          path="/programming/c"
          element={
            <React.Suspense fallback={<Loader />}>
              <C />
            </React.Suspense>
          }
        />
        <Route
          path="/programming/cpp"
          element={
            <React.Suspense fallback={<Loader />}>
              <CPP />
            </React.Suspense>
          }
        />
        <Route
          path="/programming/java"
          element={
            <React.Suspense fallback={<Loader />}>
              <Java />
            </React.Suspense>
          }
        />
        <Route
          path="/programming/python"
          element={
            <React.Suspense fallback={<Loader />}>
              <Python />
            </React.Suspense>
          }
        />
        <Route
          path="/programming/golang"
          element={
            <React.Suspense fallback={<Loader />}>
              <Golang />
            </React.Suspense>
          }
        />
        <Route
          path="/programming/javascript"
          element={
            <React.Suspense fallback={<Loader />}>
              <JavaScript />
            </React.Suspense>
          }
        />
        <Route
          path="/programming/typescript"
          element={
            <React.Suspense fallback={<Loader />}>
              <TypeScript />
            </React.Suspense>
          }
        />
        {/* Computer Science */}
        <Route
          path="/cse"
          element={
            <React.Suspense fallback={<Loader />}>
              <CSE />
            </React.Suspense>
          }
        />
        <Route
          path="/cse/discrete-mathematics"
          element={
            <React.Suspense fallback={<Loader />}>
              <DiscreteMathematics />
            </React.Suspense>
          }
        />
        <Route
          path="/cse/artificial-intelligence"
          element={
            <React.Suspense fallback={<Loader />}>
              <ArtificialIntelligence />
            </React.Suspense>
          }
        />
        <Route
          path="/cse/compiler-design"
          element={
            <React.Suspense fallback={<Loader />}>
              <CompilerDesign />
            </React.Suspense>
          }
        />
        <Route
          path="/cse/networking"
          element={
            <React.Suspense fallback={<Loader />}>
              <Networking />
            </React.Suspense>
          }
        />
        <Route
          path="/cse/numerical-methods"
          element={
            <React.Suspense fallback={<Loader />}>
              <NumericalMethods />
            </React.Suspense>
          }
        />
        <Route
          path="/cse/operating-system"
          element={
            <React.Suspense fallback={<Loader />}>
              <OperatingSystem />
            </React.Suspense>
          }
        />
        <Route
          path="/cse/theory-of-computation"
          element={
            <React.Suspense fallback={<Loader />}>
              <TheoryOfComputation />
            </React.Suspense>
          }
        />
        {/* Android Development */}
        <Route
          path="/android"
          element={
            <React.Suspense fallback={<Loader />}>
              <Android />
            </React.Suspense>
          }
        />
        <Route
          path="/android/java"
          element={
            <React.Suspense fallback={<Loader />}>
              <AJava />
            </React.Suspense>
          }
        />
        <Route
          path="/android/android-studio"
          element={
            <React.Suspense fallback={<Loader />}>
              <AStudio />
            </React.Suspense>
          }
        />
        <Route
          path="/android/android-firebase"
          element={
            <React.Suspense fallback={<Loader />}>
              <AFirebase />
            </React.Suspense>
          }
        />
        <Route
          path="/android/android-sqlite"
          element={
            <React.Suspense fallback={<Loader />}>
              <ASQLite />
            </React.Suspense>
          }
        />
        {/* Others */}
        <Route
          path="/others"
          element={
            <React.Suspense fallback={<Loader />}>
              <Others />
            </React.Suspense>
          }
        />
        <Route
          path="/others/gitandgithub"
          element={
            <React.Suspense fallback={<Loader />}>
              <Github />
            </React.Suspense>
          }
        />
        <Route
          path="/others/json"
          element={
            <React.Suspense fallback={<Loader />}>
              <JSON />
            </React.Suspense>
          }
        />
        <Route
          path="/others/restAPI"
          element={
            <React.Suspense fallback={<Loader />}>
              <RestAPI />
            </React.Suspense>
          }
        />
        <Route
          path="/others/ejs"
          element={
            <React.Suspense fallback={<Loader />}>
              <Ejs />
            </React.Suspense>
          }
        />
        <Route
          path="/others/terminal"
          element={
            <React.Suspense fallback={<Loader />}>
              <Terminal />
            </React.Suspense>
          }
        />
        {/* HSC ICT */}
        <Route
          path="/hsc"
          element={
            <React.Suspense fallback={<Loader />}>
              <HSC />
            </React.Suspense>
          }
        />
        <Route
          path="/hsc/number-system"
          element={
            <React.Suspense fallback={<Loader />}>
              <Chapter3 />
            </React.Suspense>
          }
        />
        <Route
          path="/hsc/web-design"
          element={
            <React.Suspense fallback={<Loader />}>
              <Chapter4 />
            </React.Suspense>
          }
        />
        <Route
          path="/hsc/c-programming"
          element={
            <React.Suspense fallback={<Loader />}>
              <Chapter5 />
            </React.Suspense>
          }
        />
        <Route
          path="/hsc/database"
          element={
            <React.Suspense fallback={<Loader />}>
              <Chapter6 />
            </React.Suspense>
          }
        />
        {/* Basic Computer */}
        <Route
          path="/basic-computer"
          element={
            <React.Suspense fallback={<Loader />}>
              <BasicComputer />
            </React.Suspense>
          }
        />
        <Route
          path="/basic-computer/ms-word"
          element={
            <React.Suspense fallback={<Loader />}>
              <MSWord />
            </React.Suspense>
          }
        />
        <Route
          path="/basic-computer/ms-excel"
          element={
            <React.Suspense fallback={<Loader />}>
              <MSExcel />
            </React.Suspense>
          }
        />
        <Route
          path="/basic-computer/ms-powerpoint"
          element={
            <React.Suspense fallback={<Loader />}>
              <MSPowerpoint />
            </React.Suspense>
          }
        />

        <Route
          path="/contact"
          element={
            <React.Suspense fallback={<Loader />}>
              <Contact />
            </React.Suspense>
          }
        />
        <Route
          path="/admin"
          element={
            <React.Suspense fallback={<Loader />}>
              <Admin />
            </React.Suspense>
          }
        />
        <Route
          path="*"
          element={
            <React.Suspense fallback={<Loader />}>
              <FourOFour />
            </React.Suspense>
          }
        />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
